"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPadlockFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3 5C2.44771 5 2 5.44772 2 6L2 14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14L14 6C14 5.44772 13.5523 5 13 5L11 5V4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4L5 5H3ZM9 4V5L7 5V4C7 3.44771 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM9 9C9 8.44771 8.55228 8 8 8C7.44772 8 7 8.44771 7 9L7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11L9 9Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M3.99991 7C3.44762 7 2.99991 7.44772 2.99991 8L2.99991 18C2.99991 18.5523 3.44762 19 3.99991 19H15.9999C16.5522 19 16.9999 18.5523 16.9999 18L16.9999 8C16.9999 7.44772 16.5522 7 15.9999 7L13.9999 7L13.9999 5C13.9999 2.79086 12.209 1 9.99991 1C7.79077 1 5.99991 2.79086 5.99991 5L5.99991 7L3.99991 7ZM11.9999 5V7L7.99991 7L7.99991 5C7.99991 3.89543 8.89534 3 9.99991 3C11.1045 3 11.9999 3.89543 11.9999 5ZM10.9999 12C10.9999 11.4477 10.5522 11 9.99991 11C9.44762 11 8.99991 11.4477 8.99991 12L8.99991 14C8.99991 14.5523 9.44762 15 9.99991 15C10.5522 15 10.9999 14.5523 10.9999 14L10.9999 12Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M3.99988 8C3.44759 8 2.99988 8.44772 2.99988 9L2.99988 22C2.99988 22.5523 3.44759 23 3.99988 23H19.9999C20.5522 23 20.9999 22.5523 20.9999 22L20.9999 9C20.9999 8.44772 20.5522 8 19.9999 8L16.9999 8V6C16.9999 3.23858 14.7613 1 11.9999 1C9.23845 1 6.99988 3.23858 6.99988 6L6.99988 8H3.99988ZM14.9999 6V8H8.99988L8.99988 6C8.99988 4.34315 10.343 3 11.9999 3C13.6567 3 14.9999 4.34315 14.9999 6ZM13.0001 14C13.0001 13.4477 12.5524 13 12.0001 13C11.4478 13 11.0001 13.4477 11.0001 14L11.0001 17.0001C11.0001 17.5524 11.4478 18.0001 12.0001 18.0001C12.5524 18.0001 13.0001 17.5524 13.0001 17.0001V14Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M4.4997 10C3.67127 10 2.9997 10.6716 2.9997 11.5L2.99969 29.5C2.99969 30.3284 3.67127 31 4.49969 31L27.4997 31C28.3281 31 28.9997 30.3284 28.9997 29.5L28.9997 11.5C28.9997 10.6716 28.3281 10 27.4997 10L22.9997 10V8C22.9997 4.13401 19.8657 1 15.9997 1C12.1337 1 8.99969 4.13401 8.99969 8V10H4.4997ZM19.9997 8V10L11.9997 10V8C11.9997 5.79086 13.7906 4 15.9997 4C18.2088 4 19.9997 5.79086 19.9997 8ZM17.4999 18.5C17.4999 17.6716 16.8284 17 15.9999 17C15.1715 17 14.4999 17.6716 14.4999 18.5L14.4999 22.5C14.4999 23.3284 15.1715 24 15.9999 24C16.8284 24 17.4999 23.3284 17.4999 22.5L17.4999 18.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;